import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Logo from '../Yavrio-CMYK.svg';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5"
        }}>
            <Container maxWidth="sm">
                <Box sx={{ textAlign: "center" }}>
                    <img src={Logo} alt="Yavrio Logo" style={{ height: 60, marginBottom: 32 }} />

                    <Typography variant="h3" color="error.main" sx={{ mb: 2, fontWeight: 600 }}>
                        404
                    </Typography>

                    <Typography variant="h5" color="text.primary" sx={{ mb: 2 }}>
                        Page Not Found
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: "auto" }}>
                        The page you are looking for does not exist or has been moved.
                    </Typography>

                    <Button
                        variant="contained"
                        onClick={() => navigate('/')}
                        sx={{ px: 4, py: 1.5 }}
                    >
                        Go to Home
                    </Button>

                    <style>
                        {`
                            @keyframes fadeIn {
                                from {
                                    opacity: 0;
                                    transform: translateY(-10px);
                                }
                                to {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        `}
                    </style>
                </Box>
            </Container>
        </Box>
    );
};

export default NotFound;
